import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './assets/toast.css'
import './assets/select.css'
import 'flag-icons/css/flag-icons.css'

import App from './App.vue'
import router from './router'

// Importer les utilitaires de permissions pour la console
import './utils/checkPermissions'
import './utils/menuDiagnostic'
import './utils/checkUserPermissions'

// Configuration i18n
const i18n = createI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr: {
      // Messages en français
    }
  }
})

// Configuration Toast avec style moderne et cohérent
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(Toast, toastOptions)

app.mount('#app')
